export default __webpack_public_path__ + "static/media/circle-cross.14d3da84.svg";